__turbopack_context__.v({
  "body": "_8t-cPq_body",
  "deleteBtn": "_8t-cPq_deleteBtn",
  "link": "_8t-cPq_link",
  "row": "_8t-cPq_row",
  "secondaryLabel": "_8t-cPq_secondaryLabel",
});
